export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-flag-1fd621117e8a3b5c1450fbf4751244b1.svg";